import React from 'react';
import { Theme } from '../../Enums/Theme.enum';
import Button from './Button';

interface Props {
	onClick: () => void;
	title?: string;
}

const CancelButton: React.FC<Props> = ({ onClick, title = 'base.no' }) => {
	const handlePress = () => {
		onClick?.();
	};

	return <Button onClick={handlePress} title={title} theme={Theme.RED} />;
};

export default CancelButton;
